/**
 * LegalFooter - 법정 고지 푸터 (사업자 정보)
 *
 * 결제(카드·충전·구독)가 있는 서비스는 사업자 정보를 화면에 보여야 한다(토스페이먼츠 심사).
 * 문구는 조직 공통 기준(videogen.gensapps.com 푸터)과 한 글자도 다르지 않게 유지한다.
 * 고칠 때는 다른 서비스와 함께 고친다. 이 파일 밖에 같은 문구를 두지 않는다.
 */
import React from 'react';

const SERVICE_NAME = 'GensApps Console';

const BUSINESS_INFO = [
  '상호명 젠아이랩스',
  '대표자명 PARK SU HYUN(박수현)',
  '사업자등록번호 210-32-72757',
  '주소 서울특별시 강남구 테헤란로79길 6, 3층 601호(삼성동, 제이에스타워)',
];

const CONTACT_EMAIL = 'contact@genailabs.kr';
const CONTACT_INFO = [
  '0507-1457-0220',
  '운영시간 주중 10시~17시 (점심시간 12~13시 / 주말 및 공휴일 제외)',
];

const LEGAL_LINKS = [
  { label: '이용약관', href: 'https://gensapps.com/terms-of-service' },
  { label: '개인정보처리방침', href: 'https://gensapps.com/privacy-policy' },
];

const Separator: React.FC = () => (
  <span aria-hidden="true" className="shrink-0 text-gray-300">·</span>
);

// 짧은 항목은 줄을 바꾸지 않는다. 주소 · 운영시간처럼 긴 항목만 필요할 때 안에서 줄바꿈한다.
const Item: React.FC<{ text: string; wrap?: boolean }> = ({ text, wrap = false }) => (
  <span className={wrap ? undefined : 'whitespace-nowrap'}>{text}</span>
);

const isLong = (text: string) => text.length > 30;

const InlineList: React.FC<{ items: React.ReactNode[] }> = ({ items }) => (
  <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
    {items.map((item, i) => (
      <React.Fragment key={i}>
        {i > 0 && <Separator />}
        {item}
      </React.Fragment>
    ))}
  </div>
);

export const LegalFooter: React.FC = () => (
  <footer className="border-t border-gray-200 text-xs text-gray-500">
    {/* 가로 배치는 화면 폭이 아니라 담긴 칸의 폭에 따라야 한다. 좁은 칸에서도 깨지지 않게
        문구와 링크를 위아래로 둔다 (로그인 카드 안에서 링크가 한 글자씩 쪼개졌다, #24) */}
    <div className="mx-auto max-w-6xl px-6 py-6 flex flex-col gap-3">
      <div className="min-w-0 space-y-1">
        <div>© 2026 GenAI Labs · {SERVICE_NAME}</div>
        <InlineList items={BUSINESS_INFO.map((text) => <Item key={text} text={text} wrap={isLong(text)} />)} />
        <InlineList
          items={[
            <a key="email" href={`mailto:${CONTACT_EMAIL}`} className="whitespace-nowrap hover:underline underline-offset-2">
              {CONTACT_EMAIL}
            </a>,
            ...CONTACT_INFO.map((text) => <Item key={text} text={text} wrap={isLong(text)} />),
          ]}
        />
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        {LEGAL_LINKS.map(({ label, href }) => (
          <a key={href} href={href} target="_blank" rel="noopener noreferrer" className="whitespace-nowrap hover:underline underline-offset-2">
            {label}
          </a>
        ))}
      </div>
    </div>
  </footer>
);
